<div fxLayout fxLayoutGap="16px">
  <mat-form-field>
    <input matInput placeholder="Answer Field" [formControl]="answer" />
  </mat-form-field>
</div>
